import { render, staticRenderFns } from "./ReminderHolder.vue?vue&type=template&id=63b77f4a"
import script from "./ReminderHolder.vue?vue&type=script&lang=js"
export * from "./ReminderHolder.vue?vue&type=script&lang=js"
import style0 from "./ReminderHolder.vue?vue&type=style&index=0&id=63b77f4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports